import { ColGroupDef } from 'ag-grid-community'
import { ProgramManagementRow } from '../../../programManagement'
import { productivityColumns } from './productivityColumnts'
import { profitLossColumns } from './profitLossColumns'
import { progressColumns } from './progressColumns'
import { resourceColumns } from './resourceColumns'

export const aggregationColumns: ColGroupDef<ProgramManagementRow>[] = [
  progressColumns,
  productivityColumns,
  resourceColumns,
  profitLossColumns,
]
